<template>
  <div v-if="show" class="catalog-overlay" @click="$emit('close')">
    <div class="catalog-popup" @click.stop>
      <div class="catalog-header">
        <h3>目录</h3>
        <div v-if="catalogData" class="catalog-total">
          共 {{ catalogData.volTotal || 0 }} 卷
        </div>
        <button class="close-catalog" @click="$emit('close')">
          <AppIcon name="close" size="sm" aria-label="关闭目录" />
        </button>
      </div>
      <div :ref="bindCatalogContent" class="catalog-content">
        <div v-if="loading" class="catalog-loading">加载中...</div>
        <div
          v-else-if="catalogData?.volArray?.length"
          class="catalog-list"
        >
          <div
            v-for="(vol, index) in catalogData.volArray"
            :key="index"
            class="catalog-item"
            :class="{
              active: getVolNum(vol, index) === activeVolNum,
              'is-need-login': vol.accessStatus === 'NEED_LOGIN',
              'is-locked': vol.accessStatus === 'LOCKED',
            }"
            :data-catalog-vol-num="getVolNum(vol, index)"
            @click="$emit('select', vol)"
          >
            <div class="catalog-item-cover">
              <img :src="vol.cover" :alt="vol.title" />
            </div>
            <div class="catalog-item-info">
              <div class="catalog-item-title">
                {{ vol.title }}
                <span v-if="vol.accessStatus === 'NEED_LOGIN'" class="catalog-access-tag">登录</span>
                <AppIcon
                  v-else-if="vol.accessStatus === 'LOCKED'"
                  name="lock"
                  size="sm"
                  class="catalog-vol-lock"
                />
                <AppIcon
                  v-else-if="vol.accessStatus === 'UNLOCKED'"
                  name="unlock"
                  size="sm"
                  class="catalog-vol-lock"
                />
              </div>
              <div class="catalog-item-meta">
                <div class="catalog-item-date">{{ formatDate(vol.upDate) }}</div>
                <div class="catalog-item-stats">
                  <div class="catalog-stat-item">
                    <AppIcon name="like" size="xs" class="stat-icon" aria-label="点赞数" />
                    <span class="stat-number">{{ vol.likeCount || '0' }}</span>
                  </div>
                  <div class="catalog-stat-item">
                    <AppIcon name="comment" size="xs" class="stat-icon" aria-label="评论数" />
                    <span class="stat-number">{{ vol.commentCount || '0' }}</span>
                  </div>
                </div>
              </div>
              <div class="catalog-item-progress">
                <span class="progress-label">观看进度</span>
                <div class="progress-ring-container">
                  <svg class="progress-ring" width="32" height="32" viewBox="0 0 32 32">
                    <circle
                      class="progress-ring-background"
                      cx="16"
                      cy="16"
                      r="12"
                      fill="none"
                      stroke="#d1d5db"
                      stroke-width="4"
                    />
                    <circle
                      v-if="vol.progress != null && vol.progress > 0"
                      class="progress-ring-circle"
                      cx="16"
                      cy="16"
                      r="12"
                      fill="none"
                      stroke="#a5d6a7"
                      stroke-width="4"
                      :stroke-dasharray="75.4"
                      :stroke-dashoffset="getProgressOffset(vol.progress, 12)"
                      transform="rotate(-90 16 16)"
                    />
                  </svg>
                  <span class="progress-text">
                    {{ vol.progress != null ? Math.round(vol.progress * 100) : 0 }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="catalog-end-tip">已经到底了哟</div>
        </div>
        <div v-else class="catalog-empty">暂无目录数据</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  catalogData: { type: Object, default: null },
  activeVolNum: { type: Number, required: true },
  getVolNum: { type: Function, required: true },
  formatDate: { type: Function, required: true },
  getProgressOffset: { type: Function, required: true },
  catalogContentRef: { type: Object, default: null },
})

defineEmits(['close', 'select'])

function bindCatalogContent(el) {
  if (props.catalogContentRef) {
    props.catalogContentRef.value = el
  }
}
</script>
